import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { MapSubtopicOne } from "../../objects/Tema5/MapSubtopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Teclado } from "../../objects/Tema5/Teclado";
import { Monitor } from "../../objects/Tema5/Monitor";
import { ButtonScreenPoint } from "../../objects/ButtonScreenPoint";
import { Billetes } from "../../objects/Tema5/billetes";
import { IdCard } from "../../objects/Tema5/IdCard";
import { SpinCard } from "../../objects/Tema5/SpinCard";

export class SceneTopicThree extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.teclado = new Teclado(this.loadingManager);
		this.add(this.teclado);
		this.teclado.visible = false;

		this.billeteOne = new Billetes(this.loadingManager);
		this.add(this.billeteOne);
		this.billeteOne.visible = false

		this.billeteTwo = new Billetes(this.loadingManager);
		this.add(this.billeteTwo);
		this.billeteTwo.visible = false

		this.idcard = new IdCard(this.loadingManager);
		this.add(this.idcard);
		this.idcard.visible = false

		this.spinCard = new SpinCard(this.loadingManager);
		this.add(this.spinCard);
		this.spinCard.visible = false

		this.monitor = new Monitor(this.loadingManager);
		this.add(this.monitor);
		this.monitor.visible = false

		this.buttonPointerScreen = new ButtonScreenPoint(this.loadingManager)
		this.buttonPointerScreen.rotation.y = -1.5343
		this.add(this.buttonPointerScreen)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}
	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()

				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()

				});
				break;
			default:
				// posicion escritorio 1
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true
			});
			this.teclado.visible = false
			this.monitor.visible = false
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.4;
				this.camera.control.maxDistance = 2;

				this.characterSelected.visible = false
			});
			this.monitor.visible = true
			this.monitor.scale.x = 1.333
		})
		ObserverEmitter.on(EVENTS.tema5.subtopicTwo.activityOne.amplifyDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-13.021, 0.2249, -1.1156), 1, new Vector3(-11.598, -0.316, -1.607), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 1.6;
			});
		})
		ObserverEmitter.on(EVENTS.tema5.subtopicTwo.activityOne.showOrHideModels, (status) => {
			this.characterSelected.visible = false

			this.teclado.position.set(-11.3, -0.99, -1.8);
			this.teclado.visible = status
			this.billeteOne.visible = status
			this.billeteOne.position.set(-11.3, -0.98, -0.95)
			this.billeteOne.rotation.set(0, 0.6, 0)
			this.billeteTwo.visible = status
			this.billeteTwo.position.set(-11.3, -0.96, -1.05)
			this.billeteTwo.rotation.set(0, 0.6, 0)
			this.idcard.visible = status
			this.spinCard.visible = status

			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.billeteOne,
				this.billeteTwo,
				this.idcard,
				this.spinCard,
			];
		})
		ObserverEmitter.on(EVENTS.tema5.subtopicTwo.activityOne.touchObject, (objectNumber) => {
			const animateBillets = () => {
				this.billeteOne.onAnimateBillet()
				this.billeteTwo.onAnimateBillet()
			}
			const stopBillets = () => {
				this.billeteOne.clearAnimation()
				this.billeteTwo.clearAnimation()
			}

			const touchInteractions = {
				1: [
					'Spin_Card',
					() => this.spinCard.onAnimateCard(),
					() => this.spinCard.clearAnimation(),
					1,
				],
				2: [
					'ID_Card',
					() => this.idcard.onAnimateCard(),
					() => this.idcard.clearAnimation(),
					2,
				],
				3: [
					'Billetes',
					() => animateBillets(),
					() => stopBillets(),
					3,
				],
			}

			const objecName = touchInteractions[objectNumber][0]
			const objecAnimationStart = touchInteractions[objectNumber][1]
			const objecAnimationStop = touchInteractions[objectNumber][2]
			const objecNextUI = touchInteractions[objectNumber][3]

			objecAnimationStart()

			this.mouseEvents.onPointerUp((interactions) => {
				if (interactions[0]) {
					const name = interactions[0].object.name
					const parentName = interactions[0].object.parent.name

					if (name === objecName || parentName === objecName) {
						objecAnimationStop()
						setTimeout(() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.nextUI, objecNextUI)
						}, 300)
					}
				}
			})
		})
		ObserverEmitter.on(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, (x, y, z) => {
			this.buttonPointerScreen.position.set(x, y, z)
		})
		ObserverEmitter.on(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, (status) => {
			this.buttonPointerScreen.visible = status
		})
	}

	renderAnimations(delta) {
		//animaciones
	}
}